import React, { useMemo } from 'react';
import { useTypedSelector } from '../../Hooks/useTypedSelector';
import Icon from '../Icon';
import { text } from '../../styling/mixins/typography';
import styled from 'styled-components';
import { alignCenter } from '../../styling/utils/flex';
import { translate } from '../../Services/translation';

interface StockStatusComponentProps {
  stockStatus: StockStatusProps;
  stockStatuses: { key: string; value: StockStatusProps };
  initialSelectVariantId?: string;
}

interface StockStatusProps {
  stockStatus: {
    inStock: boolean;
    description: string;
  };
}

const StyledStockStatus = styled.div<{ $inStock: boolean }>`
  ${alignCenter}
  display: flex;
  line-height: 1.2;

  svg {
    width: 1.6rem;
    height: 1.6rem;
  }

  .stock-status-description {
    ${text('medium')}
    line-height: 1.7;
  }
`;

const StockStatus: React.FC<
  StockStatusComponentProps & React.HTMLAttributes<HTMLDivElement>
> = ({ initialSelectVariantId, ...props }) => {
  const { articleNumber, stockStatuses, stockStatus } = useTypedSelector((state) => {
    return state.buyButton
  });
  
  var variantStockStatus = useMemo(() => {
    console.log('variantStockStatus',stockStatuses)
    console.log('stockStatus',stockStatus)
    console.log('articleNumber',articleNumber)

    if (articleNumber && articleNumber.length > 0 && stockStatuses) {
      
      return stockStatuses[articleNumber]
    } else if (initialSelectVariantId && initialSelectVariantId != '' && stockStatuses) {
      return stockStatuses[initialSelectVariantId]
    } else {
      return stockStatus
    }
  }, [articleNumber, stockStatuses])

  if(!stockStatus) {
    return <></>
  }


  return (
    <StyledStockStatus $inStock={variantStockStatus?.inStock} {...props}>
      {variantStockStatus ? (
        <>
          <Icon
            name={
              variantStockStatus.inStock && variantStockStatus.quantity > 0
                ? 'check-circle'
                : variantStockStatus.inStock && variantStockStatus.quantity < 1
                ? 'check-circle-orange'
                : 'cross-circle'
            }
          />
          <span className="stock-status-description">
            {variantStockStatus?.description}
          </span>
        </>
      ) : Object.values(stockStatuses).find((i) => i.inStock == true) ? (
        <>
          <Icon name={'check-circle'} />
          <span className="stock-status-description">
            {translate('product-listing.is-in-stock')}
          </span>
        </>
      ) : (
        <>
          <Icon name={'cross-circle'} />
          <span className="stock-status-description">
            {translate('product-listing.is-not-in-stock')}
          </span>
        </>
      )}
    </StyledStockStatus>
  );
};
export default StockStatus;
